import "./product-details-favorite-sign-in.scss";

export default () => {
  const modalClose = $(".js-product-details-favorite-sign-in-close");
  const modalForm = $(".js-product-details-favorite-sign-in-form");
  const errorsContainer = $(".js-product-details-favorite-sign-in-error");

  modalForm.on({
    "ajax:before": () => {
      errorsContainer.hide();
    },
    "ajax:error": (_event, error) => {
      errorsContainer.show().text(JSON.parse(error.responseText).error_message);
    }
  });

  modalClose.on("click", () => {
    errorsContainer.hide();
  });
};
